module.exports = __webpack_public_path__ + "static/img/acoes.dd706ed7.svg";